export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';

export const setSelectedFilters = selected => ({
  type: SET_SELECTED_FILTERS,
  data: selected,
});
